import $ from 'jquery';
import imask from "imask";
import onDocumentReady from "../utilities/onDocumentReady";

const updateFilled = function () {
    const value = $(this).val();
    const $component = $(this).parents('.ui-input');
    if (value) {
        $component.addClass('ui-input--filled');
    } else {
        $component.removeClass('ui-input--filled');
    }
};

const validatePhone = ($input, message) => {
    const value = $input.val().replace(/[^0-9.]/g, '');
    // если preCheck = 789 - значит пользователь начал писать 8 913 и тд
    const preCheck = value.toString().substr(0, 3);
    if (value.length !== 11 || preCheck === '789') {
        $input[0].setCustomValidity(message);
    } else {
        $input[0].setCustomValidity('');
    }
};

const setCaretPosition = (ctrl, pos) => {
    if (!ctrl) {
        return;
    }
    // Modern browsers
    if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos, pos);

        // IE8 and below
    } else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
};

$('.ui-input__control')
    .keyup(updateFilled)
    .focus(updateFilled)
    .blur(updateFilled)
    .each(updateFilled);

$('.ui-input__control').keyup(function () {
    $(this).parents('.ui-input').addClass('ui-input--touched');
}).blur(function () {
    $(this).parents('.ui-input').addClass('ui-input--touched');
});

const validatePassword = ($component) => {
    const $password = $component.parents('form').find('[name="password"]');
    const $passwordConfirm = $component.parents('form').find('[name="password_confirm"]');
    const $passwordConfirmComponent = $passwordConfirm.parents('.ui-input');

    if (!$passwordConfirmComponent.hasClass('ui-input--touched') || $passwordConfirm.length === 0) {
        return;
    }

    $password[0].setCustomValidity($password.val() === $passwordConfirm.val() ? '' : 'Пароли должны совпадать');
    $passwordConfirm[0].setCustomValidity($password.val() === $passwordConfirm.val() ? '' : 'Пароли должны совпадать');
}

$('.ui-input__control[type="password"]').keyup(function () {
    validatePassword($(this));
});

$('.ui-input--phone').each(function () {
    const $component = $(this);
    const $input = $component.find('input');
    let message = 'Проверьте, что номер телефона заполнен правильно';

    const maskOptions = {
        mask: '{+7} (000)-000-00-00',
        lazy: true, 
        overwrite: true,
        autofix: true,
        blocks: {
            ___: { mask: '000', placeholderChar: '___' },
            __: { mask: '00', placeholderChar: '__' }
        }
    };

    const phoneMask = imask($input[0], maskOptions);


    $input.on('paste', (e) => {
        e.preventDefault();
        const pastedData = (e.originalEvent || e).clipboardData.getData('Text').replace(/\D/g, '');
        if (pastedData.length === 11 && pastedData[0] === '7' || pastedData[0] === '8') {
            phoneMask.value = pastedData.slice(1);
        } else {
            phoneMask.value = pastedData;
        }
    });

    $input.focus(() => {
       
        phoneMask.updateOptions({ lazy: false });
        if ($input.val() === '') {
            $input.val('+7 (___)-___-__-__');
            setCaretPosition($input[0], 4);
        }
    });

    $input.blur(() => {
        if ($input.val() === '+7 (___)-___-__-__') {
            $input.val('');
            phoneMask.updateOptions({ lazy: true }); // Возвращаем "lazy: true" при уходе с поля
        }
    });

    $input.change(() => validatePhone($input, message));
    $input.keyup(() => validatePhone($input, message));
});



$('body').on('click', '.ui-input__password-control', function(){
    if ($(this).parent().children("input[type='password']").attr('type') == 'password'){
        $(this).addClass('ui-input__password-control--no-view');
        $(this).parent().children("input[type='password']").attr('type', 'text');
    } else {
        $(this).removeClass('ui-input__password-control--no-view');
        $(this).parent().children("input[type='text']").attr('type', 'password');
    }
    return false;
});
